<template>
  <v-card flat>
    <v-form class="resetPwd-form" ref="form" v-model="valid" lazy-validation>
      <v-card-text align="left">
        <v-text-field
          @blur="isValidatedPassMethod"
          v-model="password"
          :rules="passwordRules"
          :type="showPassword ? 'text' : 'password'"
          name="password"
          placeholder="Enter password"
          hint=""
          required
          class="r-field register-pass"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :append-outer-icon="
            pwdErrCnt == 0 ? '' : isValidatedPass ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle'
          "
          @click:append="showPassword = !showPassword"
        />
        <v-text-field
          @blur="isValidatedConfirmPassMethod"
          v-model="confirmPassword"
          :rules="passwordRules"
          :type="showPassword ? 'text' : 'password'"
          name="password"
          placeholder="Confirm password"
          hint=""
          required
          class="r-field register-pass"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :append-outer-icon="
            pwdConfirmErrCnt == 0 ? '' : isValidatedConfirmPass ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle'
          "
          @click:append="showPassword = !showPassword"
        />
      </v-card-text>
      <v-row>
        <v-col cols="12" md="3"></v-col>
        <v-col cols="12" md="6">
          <v-btn
            :disabled="!valid"
            @click="validate"
            class="resetPwd-submit"
            height="48"
            >Set Password</v-btn
          >
        </v-col>
        <v-col cols="12" md="3"></v-col>
      </v-row>
      <v-row style="display: flex; justify-content: center">
        <p class="text-center reset-notification" v-if="notifyMsg">
          Password has been set successfully.
          <br>
          You will be redirected to <a class="mx-1" small depressed @click="$router.push({ name: 'Login' })">Sign In</a> within few seconds.
        </p>
      </v-row>
      <v-card-text class="text-center terms-policy">
        <a class="subtitle-2" href="privacy-policy.html">Privacy policy</a> & <a class="subtitle-2" href="terms-of-use.html">Term of use</a>
      </v-card-text>
    </v-form>
  </v-card>
</template>
<script>
export default {
  name: 'ResetPasswordForm',
  data() {
    return {
      showPassword: false,
      valid: true,
      password: '',
      confirmPassword: '',
      errMsg: false,
      pwdErrCnt: 0,
      pwdConfirmErrCnt: 0,
      passwordRules: [
        (value) => !!value || 'Password is required',
        (v) => v.length >= 6 || 'Min 6 characters',
        (v) => (!!v && v) === this.password || 'Passwords do not match'
      ],
      validPassRegEx: /^.{6,}$/,
      notifyMsg: false
    }
  },
  computed: {
    isValidatedPass() {
      return this.password !== null && this.validPassRegEx.test(this.password)
    },
    isValidatedConfirmPass() {
      return (
        this.confirmPassword !== null &&
        this.validPassRegEx.test(this.confirmPassword) &&
        this.confirmPassword === this.password
      )
    }
  },
  watch: {
    isValidatedPass: {
      deep: true,
      handler: function (newVal) {
        this.pwdErrCnt++
      }
    },
    isValidatedConfirmPass: {
      deep: true,
      handler: function (newVal) {
        this.pwdConfirmErrCnt++
      }
    }
  },
  methods: {
    isValidatedPassMethod() {
      const validRegEx = /^.{1,}$/
      if (this.password === '' && !validRegEx.test(this.password)) {
        this.pwdErrCnt = 1
      }
    },
    isValidatedConfirmPassMethod() {
      const validRegEx = /^.{1,}$/
      if (
        this.confirmPassword === '' &&
        !validRegEx.test(this.confirmPassword)
      ) {
        this.pwdConfirmErrCnt = 1
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.setPassword()
      }
    },
    async setPassword() {
      const verificationData = JSON.parse(
        localStorage.getItem('verificationData1')
      )
      await this.$store
        .dispatch('user/resetPassword', {
          email: verificationData.email,
          token: verificationData.token,
          password: this.password
        })
        .then((res) => {
          localStorage.removeItem('verificationData1')
          if (res.data.error.type === 200) {
            this.notifyMsg = true
            setTimeout(() => {
              this.$router.push({ name: 'Login' })
            }, 7000)
          } else {
            this.notifyMsg = false
          }
        })
    }
  }
}
</script>

<style lang="css">
.register-pass {
  font-size: 1.1rem !important;
}
.resetPwd-form {
  font-size: 1.2rem !important;
  color: #413967;
  font-family: 'Source Sans 3', sans-serif;
}
.label-field {
  font-size: 1.2rem !important;
}
.resetPwd-submit {
  font-weight: 500;
  width: 180px !important;
  background-color: #7671bd !important;
  color: white !important;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 1rem !important;
  transition: .3s;
}
.resetPwd-submit:hover {
  background-color: #534f8c !important;
  color: white !important;
  font-weight: 500;
  font-size: 1rem !important;
}
.v-textfield {
  margin-top: 0px;
  padding-top: unset;
}
.r-field {
  padding-top: unset;
  margin-top: unset;
}
.v-messages__message {
  color: #ff5252;
}
.resetPwd-errMsg {
  padding: 0;
  font-size: 18px;
  color: #ff5252;
}
.agree-terms {
  font-weight: 700;
  font-size: 1rem;
  font-family: 'Source Sans 3', sans-serif;
  padding-left: 5px;
}
.agree-label .v-input__slot i {
  font-size: 20px;
  font-family: 'Source Sans 3', sans-serif;
}
.reset-notification {
  color: #0b9b55;
  font-size: 18px;
  font-family: 'Source Sans 3', sans-serif;
  margin-top: 20px;
}
.reset-notification .mx-1 {
  color: #7671bd !important;
  text-decoration: underline;
}
.reset-notification .mx-1:hover {
  cursor: pointer;
}
.subtitle-2 {
  text-decoration: none;
  color: #414c6c;
  margin-top: 20px;
  font-size: 16px !important;
}
.v-messages__message {
    color: #ff5252;
    font-size: 13px;
}
.v-text-field > .v-input__control > .v-input__slot:after {
border-color: #7671bd!important;
}
</style>
